// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3WjsY","title":"ClientCherryInfo_title__85k3g","itemText":"ClientCherryInfo_itemText__3kFzh"};